/* eslint no-template-curly-in-string: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { SelectPickerField } from 'components/form/selectpicker'
import CheckboxField from 'components/form/checkbox'
import TweetField from 'pages/widgets/form/tweet-input/'
import PromotedOnlyCheckboxField from 'pages/widgets/form/promoted-only-checkbox/'

const selector = formValueSelector('widget')

const hasCampaignConfigured = campaign =>
  !!(campaign && (campaign.id || (campaign.name || '').trim()))

export const SendReplyField = ({
  name,
  selectedAction,
  hasCampaign,
  hasRedirect
}) => (
  <div className='row'>
    <div className='col-sm-3 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='SEND_REPLY'
      >
        <option value='SEND_REPLY'>Tweet</option>
        <option value='SEND_DM'>DM</option>
      </Field>
    </div>
    <div
      className={
        (selectedAction === 'SEND_REPLY' ? 'br-has-checkbox ' : 'br-is-dm ') +
        'col-sm-9 br-no-pad-left'
      }
    >
      <TweetField
        messageName={`${name}.message`}
        urlName={`${name}.attachmentUrl`}
        cardUriName={`${name}.cardUri`}
        isDM={selectedAction === 'SEND_DM'}
      />
      {selectedAction === 'SEND_REPLY' ? (
        <PromotedOnlyCheckboxField name={name} />
      ) : null}
      {selectedAction === 'SEND_REPLY' && hasCampaign ? (
        <div className='br-missed-post-redirect'>
          <Field
            name={`${name}.hasMissedPostRedirect`}
            component={CheckboxField}
            className='icheckbox_square'
            label='Redirect to the earliest missed campaign post'
          />
          {hasRedirect ? (
            <Field
              name={`${name}.missedPostRedirect.message`}
              component='textarea'
              className='form-control'
              rows={2}
              placeholder='Reply sent when the user missed an earlier post, e.g. You missed one @${senderHandle} ${missedPostUrl}'
            />
          ) : null}
        </div>
      ) : null}
    </div>
  </div>
)

SendReplyField.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string,
  hasCampaign: PropTypes.bool,
  hasRedirect: PropTypes.bool
}

const ReplyWithAction = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`),
  hasCampaign: hasCampaignConfigured(selector(state, 'intentBased.campaign')),
  hasRedirect: Boolean(selector(state, `${props.name}.hasMissedPostRedirect`))
}))(SendReplyField)

export default ReplyWithAction



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-reply/index.js